// extracted by mini-css-extract-plugin
export default {"container":"MonitorToggle_container__NmaNU","text":"MonitorToggle_text__gNBKa"};